import { useEffect, useRef } from "react";

export interface TooltipProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  onShowTooltipChange: (newValue: boolean) => void;
}

function TooltipHelper(props: TooltipProps) {
  const tooltipRef = useRef(null);

  useEffect(() => {
    if (tooltipRef.current) {
      const tag = tooltipRef.current as HTMLElement;
      const parentWidth =
        tag.parentElement?.parentElement?.getBoundingClientRect().width; // 获取元素父级可视宽度
      const contentWidth = tag.offsetWidth; // 获取元素可视宽度
      props.onShowTooltipChange(
        !!(parentWidth && Math.floor(contentWidth) > Math.floor(parentWidth))
      );
    }
  }, [props.children]);

  return (
    <div className="absolute truncate" style={{ visibility: "hidden" }}>
      <span ref={tooltipRef}>{props.children}</span>
    </div>
  );
}

export default TooltipHelper;
